import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePicker.css'; // Custom styles

const CustomDatePicker = ({
    label,
    selectedDate,
    onChange,
    placeholder = "Select Date",
    className = "",
    minDate,
    maxDate,
    isClearable = false
}) => {
    return (
        <div className={`custom-datepicker-wrapper ${className}`}>
            <DatePicker
                selected={selectedDate}
                onChange={onChange}
                dateFormat="yyyy-MM-dd"
                className="form-control form-control-sm stylish-datepicker"
                placeholderText={placeholder}
                minDate={minDate}
                maxDate={maxDate}
                isClearable={isClearable}
                renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled
                }) => (
                    <div className="d-flex justify-content-between align-items-center px-2 py-1 bg-light border-bottom">
                        <button
                            onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                decreaseMonth();
                            }}
                            disabled={prevMonthButtonDisabled}
                            className="btn btn-sm btn-outline-secondary"
                        >
                            ‹
                        </button>

                        <div className="d-flex gap-2 align-items-center">
                            <select
                                value={date.getFullYear()}
                                onChange={({ target: { value } }) => changeYear(Number(value))}
                                className="form-select form-select-sm"
                            >
                                {Array.from({ length: 30 }, (_, i) => {
                                    const year = new Date().getFullYear() - 15 + i;
                                    return <option key={year} value={year}>{year}</option>;
                                })}
                            </select>

                            <select
                                value={date.getMonth()}
                                onChange={({ target: { value } }) => changeMonth(Number(value))}
                                className="form-select form-select-sm"
                            >
                                {[
                                    'January', 'February', 'March', 'April', 'May', 'June',
                                    'July', 'August', 'September', 'October', 'November', 'December'
                                ].map((month, idx) => (
                                    <option key={idx} value={idx}>{month}</option>
                                ))}
                            </select>
                        </div>

                        <button
                            onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                increaseMonth();
                            }}
                            disabled={nextMonthButtonDisabled}
                            className="btn btn-sm btn-outline-secondary"
                        >
                            ›
                        </button>
                    </div>
                )}
            />
        </div>
    );
};

export default CustomDatePicker;
